import { render } from "./DesktopSplash.vue?vue&type=template&id=1e4c5418&scoped=true"
import script from "./DesktopSplash.vue?vue&type=script&lang=js"
export * from "./DesktopSplash.vue?vue&type=script&lang=js"

import "./DesktopSplash.vue?vue&type=style&index=0&id=1e4c5418&lang=scss&scoped=true"

import exportComponent from "/nodeApps/scrawl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4c5418"]])

export default __exports__